export default "/assets/images/performance-filter-img-03.png?5201de4aa11e1ce6c6ca0c89ee5da166";